import React from 'react';
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';

const ScholarshipPin = () => {
  return (
    <Link
      to="/scholarship"
      state={{ showPsat: true }}
      aria-label="PSAT 2026 Scholarship"
      className="fixed right-0 top-1/2 -translate-y-1/2 z-40 flex items-center gap-2 bg-red-800 hover:bg-red-900 text-white font-semibold text-sm pl-3 pr-4 py-2.5 rounded-l-full shadow-lg transition-colors"
    >
      <span className="relative flex">
        <Bell className="h-5 w-5 animate-bounce" />
        <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-yellow-400 animate-ping" />
        <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-yellow-400" />
      </span>
      <span className="hidden sm:inline">PSAT 2026</span>
    </Link>
  );
};

export default ScholarshipPin;
